'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product20__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.oJ;
      break;
    }
    case 1: {
      return $thiz.oU;
      break;
    }
    case 2: {
      return $thiz.oW;
      break;
    }
    case 3: {
      return $thiz.oX;
      break;
    }
    case 4: {
      return $thiz.oY;
      break;
    }
    case 5: {
      return $thiz.oZ;
      break;
    }
    case 6: {
      return $thiz.p0;
      break;
    }
    case 7: {
      return $thiz.p1;
      break;
    }
    case 8: {
      return $thiz.p2;
      break;
    }
    case 9: {
      return $thiz.oK;
      break;
    }
    case 10: {
      return $thiz.oL;
      break;
    }
    case 11: {
      return $thiz.oM;
      break;
    }
    case 12: {
      return $thiz.oN;
      break;
    }
    case 13: {
      return $thiz.oO;
      break;
    }
    case 14: {
      return $thiz.oP;
      break;
    }
    case 15: {
      return $thiz.oQ;
      break;
    }
    case 16: {
      return $thiz.oR;
      break;
    }
    case 17: {
      return $thiz.oS;
      break;
    }
    case 18: {
      return $thiz.oT;
      break;
    }
    case 19: {
      return $thiz.oV;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 19)"));
    }
  }
}
export { $f_s_Product20__productElement__I__O as $f_s_Product20__productElement__I__O };
